module.exports = __webpack_public_path__ + "img/je.6aa4bed9.svg";